
import ConditionsText from '../views/notice/ConditionsText.vue';

export default {
  name: 'ConditionsComponent',
  components: { ConditionsText },
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' });
    },
  },
};
